/**
 * Legal and recommended minimums in mm. Both are season- and country-dependent
 * (Norway: 1.6/3.0 summer, 3.0/4.6 winter), so they always come from the wheel
 * set record — never hardcoded in the UI.
 */
export type TreadDepthThresholds = {
  limitMm: number;
  recommendedMm: number;
};

export type TreadDepthTone = 'good' | 'soon' | 'worn';

/**
 * Mirrors the backend's wheel-set status thresholds exactly (`<= limit` is worn
 * out, `<= recommended` is soon worn out) so a per-wheel cell can never
 * disagree with the set-level badge the same API returns.
 */
export const treadDepthTone = (valueMm: number, { limitMm, recommendedMm }: TreadDepthThresholds): TreadDepthTone => {
  if (valueMm <= limitMm) {
    return 'worn';
  }
  if (valueMm <= recommendedMm) {
    return 'soon';
  }
  return 'good';
};
